import { Component, OnInit, ViewChild, Input, Signal, WritableSignal, signal, AfterViewInit } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, ConfirmationService, FilterService } from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { AppMainComponent } from 'src/app/app.main.component';
import { Statut } from 'src/app/entites/statut';
import { BonTravailEntite } from 'src/app/entites/mecanique/bon-travail';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AchatService } from 'src/app/services/achat-service';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { EntretienPreventifEntite } from 'src/app/entites/mecanique/entretien-preventif';
import { Item } from 'src/app/entites/item';
import { HistoriqueEntretienComponent } from 'src/app/controles/mecanique/historique-entretien.component';
import { DepartementEntite } from 'src/app/entites/departement';
import { Emplacement } from 'src/app/entites/emplacement';
import { ItemService } from 'src/app/services/item-service';
import { EStatutsSpeciaux } from 'src/app/entites/enums/statuts-speciaux';
import { ItemMin } from 'src/app/entites/item-min';
import { AssignerEntretiensComponent } from '../bonsTravail/controles/assigner-entretiens.component';
import { EntretienPreventifService } from 'src/app/services/entretien-preventif-service';
import { DepartementMecaniqueEntite } from 'src/app/entites/mecanique/departement-mecanique';
import { HttpEvent, HttpEventType } from "@angular/common/http";

@Component({
    templateUrl: './planification.component.html',
    styleUrls: ['./planification.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class PlanificationComponent extends BaseComponent implements OnInit, AfterViewInit {

    entretiensComplet: EntretienPreventifEntite[];
    entretiens: EntretienPreventifEntite[];

    selectionMultipleEntretiens: EntretienPreventifEntite[] = [];

    statuts: Statut[] = this.sdb.Statuts();

    departements: DepartementMecaniqueEntite[];
    departement: DepartementMecaniqueEntite;
    emplacements: Emplacement[];
    emplacement: Emplacement;
    unites: Signal<ItemMin[]>;
    unite: ItemMin;

    assignations: string[];
    selectionAssignations: string[];
    assignationSelection: string;

    date: Date[] = [new Date()];

    loadingEvent: WritableSignal<HttpEvent<any>> = signal(null);
    loadingError: WritableSignal<string> = signal(null);
    

    contenuMenuContextuelEntretien: MenuItem[];

    menu: MenuItem[];

    @ViewChild('dt') table: Table;
    @ViewChild('menuContextuelEntretien') menuContextuelEntretien: ContextMenu;
    
    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private bonTravailService: BonTravailService,
        private itemService: ItemService,
        private entretienPreventifService: EntretienPreventifService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        private filterService: FilterService) {

            super(sdb, profilService, route, routerService, appMain);
            
        this.breadcrumbService.setItems([
            { label: 'Planification' }
        ]);

        // Register custom filter for assignation that checks if any selected value is contained in the field
        this.filterService.register('assignationContains', (value: string, filter: string[]): boolean => {
            if (!filter || filter.length === 0) return true;
            if (!value) return false;
            return filter.some(f => value.includes(f));
        });
    }

    ngOnInit() {

        this.verifierAccesPage('temp_mec');

        this.colonnesDisponibles = [
            /* { champ: 'projet', entete: 'Projet', afficheParDefaut: true },
            { champ: 'nbItems', entete: 'Nb items', afficheParDefaut: false },
            { champ: 'coutTotal', entete: 'Coût total', afficheParDefaut: false },
            { champ: 'employe', entete: 'Employé', afficheParDefaut: true },
            { champ: 'dateEnvoi', entete: 'Date d\'envoi', afficheParDefaut: true },
            { champ: 'envoyeA', entete: 'Envoyé à', afficheParDefaut: true } */
        ];
        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.departements = this.sdb.DepartementsMecanique();
        this.emplacements = this.sdb.Emplacements();

        this.assignations = this.sdb.Employes().map(x => x.prenom + ' ' + x.nom).concat(this.sdb.Emplacements().map(x => x.nom));
        this.selectionAssignations = [];
        this.assignationSelection = null;

        this.statuts = [
            this.sdb.Statut(EStatuts.AFaire),
            this.sdb.Statut(EStatuts.EnCours),
            this.sdb.Statut(EStatuts.EnRetard),
            this.sdb.Statut(EStatuts.OK)
        ]

        var p1 = new Promise<number>((resolve, reject) => {
            this.entretienPreventifService.Obtenir().then(x => {
                this.entretiensComplet = x.valeur;
                // Add assignation property to each entretien for filtering
                this.entretiensComplet.forEach(entretien => {
                    entretien['assignation'] = this.getAssignation(entretien);
                });
                this.entretiens = x.valeur;
                resolve(null);
            });
        });

        var p2 = new Promise<number>((resolve, reject) => {
            this.itemService.ObtenirItems(null).subscribe({
                next: (x) => {
                    if (x.type == HttpEventType.Response) {
                        this.unites = x.body.value;
                        resolve(null);
                    }
                    this.loadingEvent.set(x);
                },
                error: (error) => {
                    this.loadingError.set(error.error);
                }
            });
        });

        Promise.all([p1, p2]).then(x => {

            this.initialiserMenu();

            this.CompleterChargement();
        });
       
    }

    ngAfterViewInit() {
        this.chargerColonnesSelectionnees();
    }

    initialiserMenu() {

        this.menu = [
            // {
            //     label: 'Imprimer', icon: 'pi pi-fw pi-print'
            // },
            {
                visible: this.estAutorise('temp_mec'),
                disabled: this.selectionMultipleEntretiens.length == 0,
                label: 'Assigner', 
                icon: 'pi pi-fw pi-user', 
                command: () => this.assigner(this.selectionMultipleEntretiens)
            },
            /* {
                label: 'Actions multiples', icon: 'pi pi-fw pi-bars',
                visible: this.estAutorise('temp_mec'),
                disabled: this.selectionMultipleEntretiens.length == 0,
                items: [
                    {
                        label: 'Assigner', icon: 'pi pi-fw pi-user', command: () => this.assigner(this.selectionMultipleEntretiens)
                    },
                ]
            }, */
        ];
    }

    surChangementSelectionEntretiens() {
        this.initialiserMenu();
    }

    assigner(entretiens: EntretienPreventifEntite[]) {

        if (entretiens.filter(x => x.statut.statutId == EStatuts.EnCours).length > 0) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Vous ne pouvez pas assignger un entretien qui est déjà en cours dans un bon de travail.' });
            return;
        }

        if ([...new Set(entretiens.map(x => x.item.itemId))].length > 1) {
            
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Vous ne pouvez pas assigner des entretiens associés à des unités différentes.' });
            return;
        }

        const ref = this.dialogService.open(AssignerEntretiensComponent, {
            data: {
                itemId: entretiens[0].item.itemId,
                entretiensPreventifs: entretiens,
                employeId: this.profilService.ProfilCourant().employeId,
                contreMaitreId: entretiens[0].item.departementMecanique?.contreMaitre?.employeId
            },
            header: `Assigner des entretiens`,
            width: '75%'
        }).onClose.subscribe((bt: BonTravailEntite) => {

            if (bt) {
                 entretiens.forEach(ent => {
                ent.bonTravail = bt;
                ent.statut = this.sdb.Statut(EStatuts.EnCours);
            });
          
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail créé.' });
            this.selectionMultipleEntretiens = [];
            }
            

        });

    }

    surMenuContextuelEntretien(event, entretien: EntretienPreventifEntite) {

        this.contenuMenuContextuelEntretien = [
            { 
                label: 'Voir le bon de travail', 
                icon: 'pi pi-fw pi-eye', 
                visible: this.estAutorise('temp_mec') && entretien.bonTravail != null && entretien.bonTravail != undefined,
                command: () => this.routerService.navigateByUrl('mecanique/bontravails/' + entretien.bonTravail.bonTravailId) 
            },
            { 
                label: 'Voir l\'unité', 
                icon: 'pi pi-fw pi-eye', 
                visible: this.estAutorise('temp_mec'),
                command: () => this.routerService.navigateByUrl('item/' + entretien.item.itemId) 
            },
            {
                label: 'Voir l\'historique', icon: 'pi pi-fw pi-calendar',
                visible: this.estAutorise('temp_mec'), // TODO : && est entretien préventif
                command: _ => this.consulterHistoriqueEntretienPreventif(entretien.item, entretien)
            },
            {separator: true},
            { 
                label: 'Assigner', 
                icon: 'pi pi-fw pi-user', 
                visible: this.estAutorise('temp_mec'),
                command: () => this.assigner([entretien])
            }
        ];

        this.menuContextuelEntretien.toggle(event);
    }

    consulterHistoriqueEntretienPreventif(item: Item, entretien: EntretienPreventifEntite) {
        const ref = this.dialogService.open(HistoriqueEntretienComponent, {
            data: {
                itemId: item.itemId,
                entretienPreventifId: entretien.entretienPreventifId
            },
            header: `Historique d'entretien - ${item.numero} - ${item.description} - ${entretien.description}`,
            width: '75%'
        }).onClose.subscribe(() => {


        });
    }

    filtrer() {
        this.Bloquer();
           this.entretiens = this.entretiensComplet;
           if (this.unite) {
               this.entretiens = this.entretiens.filter(x => x.item.itemId == this.unite.itemId);
           }
           if (this.emplacement) {
            this.entretiens = this.entretiens.filter(x => x.item.emplacement.emplacementId == this.emplacement.emplacementId);
        }
        if (this.departement) {
            this.entretiens = this.entretiens.filter(x => x.item.departementMecanique && x.item.departementMecanique.departementMecaniqueId == this.departement.departementMecaniqueId);
        }
        if (this.assignationSelection) {
            // Use includes to match both direct assignment and employee's current emplacement
            this.entretiens = this.entretiens.filter(x => this.getAssignation(x).includes(this.assignationSelection));
        }
        
        // Update assignation property for filtered items
        this.entretiens.forEach(entretien => {
            entretien['assignation'] = this.getAssignation(entretien);
        });
        
        this.Debloquer();
    }

    retirerFiltres() {
        this.entretiens = this.entretiensComplet;
        this.unite = null;
        this.departement = null;
        this.emplacement = null;
        this.assignationSelection = null;
        this.selectionAssignations = [];
        
        // Update assignation property for all items
        this.entretiens.forEach(entretien => {
            entretien['assignation'] = this.getAssignation(entretien);
        });
    }

    /**
     * Build assignation string for filtering - includes employee name AND their current emplacement.
     * This allows filtering by emplacement to also find items assigned to employees currently at that emplacement.
     */
    getAssignation(entretien: EntretienPreventifEntite): string {
        if (entretien.item.employe) {
            let assignation = entretien.item.employe.prenom + ' ' + entretien.item.employe.nom;
            // Add employee's current emplacement for filtering purposes
            if (entretien.item.emplacementCourantEmploye?.nom) {
                assignation += '|' + entretien.item.emplacementCourantEmploye.nom;
            }
            return assignation;
        } else if (entretien.item.emplacement) {
            return entretien.item.emplacement.nom;
        }
        return '';
    }

}
